const welcomeScreenIcon = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
			<path
				d="M 10 3 L 10 4 L 10 13 L 12 13 L 12 5 L 26 5 L 26 27 L 12 27 L 12 19 L 10 19 L 10 28 L 10 29 L 11 29 L 27 29 L 28 29 L 28 28 L 28 4 L 28 3 L 27 3 L 11 3 L 10 3 z M 16.34375 11.28125 L 14.90625 12.71875 L 17.1875 15 L 5 15 L 5 17 L 17.1875 17 L 14.90625 19.28125 L 16.34375 20.71875 L 20.34375 16.71875 L 21.03125 16 L 20.34375 15.28125 L 16.34375 11.28125 z"
				overflow="visible"
			/>
		</svg>
	);
};
export default welcomeScreenIcon;
